/** @format */

import {Typography} from '@mui/material';
import {Trans} from 'react-i18next';

import {StubContainer} from './styles';
import {SectionTitle} from '../../styles';
import Stub from './images/stub.svg?react';

const ReportsStub = () => {
  return (
    <StubContainer>
      <SectionTitle>
        <Trans>Результаты исследований</Trans>
      </SectionTitle>
      <Typography variant='body2'>
        <Trans>Закажите ИИ-исследование и оно появится здесь</Trans>
      </Typography>

      <Stub style={{margin: 'auto'}} />
    </StubContainer>
  );
};
export default ReportsStub;
